import { createPairHoldersTableColumns } from '../../holders-table/atoms/reatom-pair-holders-columns'

import type { TopTradersTableColumnId } from './reatom-top-traders-column-id'
import type { PairAddress, PairModel } from '@root/entities/pair'
import type { Maker } from '@root/entities/trade'
import type { Column } from '@root/shared/ui-kit'

export const createTopTradersTableColumns = (options: { pair: PairModel }) => {
  const columns: Array<
    Column<
      Maker.RankedMaker,
      TopTradersTableColumnId,
      { pairAddress: PairAddress }
    >
  > = createPairHoldersTableColumns({ pair: options.pair })

  return columns
}
